// Jul-2026 (User-Wunsch) — Datei-Übergabe zwischen Seiten im selben Tab
// (z. B. Postausgang → Lieferschein-Scan), ohne Serialisierung.
let _file = null;

export const setHandoffFile = (f) => { _file = f; };

export const takeHandoffFile = () => {
    const f = _file;
    _file = null;
    return f;
};

// Aug-2026 (User-Bug „Datei trotz Fehler gelöscht"): Aufräumen (Löschen aus dem
// überwachten Ordner) erst NACH erfolgreichem Folge-Vorgang — nie beim Handoff.
let _cleanup = null; // { file, fn }

export const setHandoffCleanup = (file, fn) => { _cleanup = fn ? { file, fn } : null; };

export const runHandoffCleanup = async (file) => {
    if (!_cleanup || (file && _cleanup.file !== file)) return false;
    const { fn } = _cleanup;
    _cleanup = null;
    try { await fn(); return true; } catch { return false; }
};
